import { useState } from "react";
import { linkKey } from "../signedLinks";

/**
 * A customer's picture, over the coloured initial its parent draws. It keeps
 * the link it first loaded for as long as the picture is the same one: the API
 * signs every link afresh on each answer, and a new link is a new download —
 * every picture in the chat list, every 15 seconds (2026-10-20). A link that
 * has run out by the time it is drawn gives way to the newest one; with none
 * newer the picture is left out and the initial shows until one comes.
 */
export default function AvatarPic({ url }: { url?: string }) {
  const [shown, setShown] = useState(url ?? "");
  const [failed, setFailed] = useState("");
  // Another picture, or a newer link after this one failed: drawn from it
  // (React's pattern for state that follows a prop, set while rendering).
  if (linkKey(shown) !== linkKey(url) || (failed === shown && url && url !== shown)) setShown(url ?? "");
  if (!shown || failed === shown) return null;
  return <img src={shown} alt="" onError={() => (url && url !== shown ? setShown(url) : setFailed(shown))} />;
}
